<div class="preloader-area">
    <div class="lds-hourglass"></div>
</div>
<app-header></app-header>
    <router-outlet></router-outlet>
<app-footer></app-footer>
